import { Store } from './store';
import { AppConfigStore } from './app-config.store';
import { UiStore } from './ui.store';
import { DaysPlannerStore } from './day-planner.store';
import { GuidesStore } from './guides.store';
import { ShoppingListStore } from './shopping-list.store';

export const STORES: any[] = [ Store, AppConfigStore, UiStore, DaysPlannerStore, GuidesStore, ShoppingListStore ];
